import {MAP_CONFIG} from "../utils/constants";

export function useMapZoomControls(map: google.maps.Map | null) {
    const adjustZoom = (delta: number) => {
        const currentZoom = map?.getZoom();
        if (currentZoom == null || !map) return;
        map.setZoom(
            Math.max(MAP_CONFIG.MIN_ZOOM, Math.min(MAP_CONFIG.MAX_ZOOM, currentZoom + delta))
        );
    };

    const zoomIn = () => adjustZoom(1);
    const zoomOut = () => adjustZoom(-1);

    return {zoomIn, zoomOut};
}
